import React from 'react';
import { Link } from 'react-router-dom';
import VehicleBrandLogo from './VehicleBrandLogo';
import { useSelectedVehicle } from '../services/vehicleStore';
import GarageSwitcher from './GarageSwitcher';
import { useT } from '../services/i18n';

// Compact « parts for your vehicle » card (cart + checkout summary): model picture + make logo + label
const CartVehicleCard = ({ testId = 'cart-vehicle', compact = false, garage = false }) => {
  const { t } = useT();
  const vehicle = useSelectedVehicle();
  const size = compact ? 56 : 72;
  return (
    <>
      {vehicle && (
        <div data-testid={testId} className={`relative flex items-center gap-3 rounded-lg border border-orange-200 bg-gradient-to-r from-orange-50 to-white ${compact ? 'p-2.5 pr-9' : 'p-3 pr-10'} mb-4`}>
          <VehicleBrandLogo brand={vehicle.brand} size={compact ? 22 : 26} testId={`${testId}-logo`} className="absolute top-1.5 right-1.5 shadow-sm" />
          <VehicleBrandLogo brand={vehicle.brand} model={vehicle.model} size={size} preferModel zoom testId={`${testId}-model`} className="!border-orange-100" />
          <div className="min-w-0 flex-1">
            <p className="text-[11px] font-medium text-orange-700 uppercase tracking-wide">{t('cart.forVehicle')}</p>
            <p className="text-sm font-semibold text-gray-900 truncate" data-testid={`${testId}-label`}>{vehicle.brand} {vehicle.model} <span className="text-gray-500 font-normal">({vehicle.year})</span></p>
            <p className="text-xs text-gray-600 truncate">{vehicle.engine?.name}{vehicle.plate ? ` · ${vehicle.plate}` : ''}</p>
          </div>
          {!compact && <Link to="/" className="absolute bottom-2 right-2 text-xs text-blue-600 hover:underline" data-testid={`${testId}-change`}>{t('cat.change')}</Link>}
        </div>
      )}
      {garage && <GarageSwitcher vehicle={vehicle} testId={testId} className="mb-4" />}
    </>
  );
};

export default CartVehicleCard;
